import { CloudflareWarning } from "./components/CloudflareWarning/CloudflareWarning";
import { DowngradedPerformance } from "./components/DowngradedPerformance/DowngradedPerformance";
import { TimeSyncWarning } from "./components/TimeSyncWarning/TimeSyncWarning";
import { useSystemAlertsController } from "./SystemAlerts.controller";

export const SystemAlerts = () => {
  const {
    isDowngradedPerformanceInvisible,
    isCloudflareWarningInvisible,
    isTimeSyncWarningInvisible,
  } = useSystemAlertsController();

  const children = [
    !isDowngradedPerformanceInvisible && (
      <DowngradedPerformance key="downgraded" />
    ),
    !isTimeSyncWarningInvisible && <TimeSyncWarning key="timesync" />,
    !isCloudflareWarningInvisible && <CloudflareWarning key="cloudflare" />,
  ]
    .filter(Boolean)
    .slice(0, 2);

  return <div className="flex flex-col gap-4">{children}</div>;
};
